export class Vessels implements IResponseList<TypeVessel> {
  message?: string;
  status_code: number;
  warning?: string | null | undefined;
  data: TypeVessel[];
  errors?: ExpectedAny[] | undefined;
  page: number;
  page_size: number;
  total_pages: number;
  total_records: number;
  ship_types?: Array<{
    name: string
    id: number
  }>
  operators?: Array<TypeVesselOperator>
  shared_line_services?: Array<TypeVesselOperator>
  owners?: Array<TypeVesselOperator>
  constructor() {
    (this.status_code = 200), (this.data = []);
    this.page = 0;
    this.page_size = 0;
    this.total_pages = 0;
    this.total_records = 0;
    this.ship_types = []
    this.operators = []
  }
}

export class VesselDetail implements IResponse<TypeVesselDetail> {
  message?: string;
  status_code: number;
  warning?: string | null | undefined;
  data: TypeVesselDetail;
  errors?: ExpectedAny[] | undefined;
  page: number;
  page_size: number;
  total_pages: number;
  total_records: number;
  trip: {
    origin_locode?: string
    origin_country_code?: string
    Destination_locode?: any
    destination_country_code?: any
    destination_name?: any
    destination_lat?: any
    destination_lon?: any
    origin_name?: string
    departure?: string
    eta?: string
    percent?: string
  }
  positions: Array<{
    lat?: number
    lon?: number
    navstat?: number
    heading?: number
    speed?: number
    destination?: string
    ref_period: string
    eta?: string
  }>
  schedules: Array<{
    index: number
    mmsi: number
    teu: number
    shared_loop_header_id: any
    lat: number
    lon: number
    name: string
    service_id: Array<any>
    next_stop: any
    next_eta: string
    start_date: string
    end_date: string
    delay_text: any
    locode: string
    voyage?: string
    actual_start?: string
    actual_end?: string
    region: string
    delay: string
    terminal_name?: string
    loop_code: any
    timezone: string
    direction: any
    updated_on: string
    start_dt: string
    end_dt: string
  }>
  constructor() {
    (this.status_code = 200), (this.data = []);
    this.page = 0;
    this.page_size = 0;
    this.total_pages = 0;
    this.total_records = 0;
    this.trip = {}
    this.positions = []
    this.schedules = []
  }
}